/* +1-800-ART-DEPT. — theme interactions (vanilla, no deps) */
(function () {
  "use strict";

  /* ---- scroll reveal ---- */
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window) || !els.length) {
      els.forEach(function (el) {
        el.classList.add("is-in");
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "-80px 0px" }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---- hero intro ---- */
  function initHero() {
    var hero = document.querySelector("[data-hero]");
    if (hero) {
      requestAnimationFrame(function () {
        setTimeout(function () {
          hero.classList.add("is-ready");
        }, 60);
      });
    }
  }

  /* ---- menu overlay ---- */
  function initMenu() {
    var overlay = document.querySelector("[data-menu]");
    if (!overlay) return;
    var openers = document.querySelectorAll("[data-menu-open]");
    var closers = document.querySelectorAll("[data-menu-close]");
    function open() {
      overlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }
    function close() {
      overlay.classList.remove("is-open");
      document.body.style.overflow = "";
    }
    openers.forEach(function (b) {
      b.addEventListener("click", open);
    });
    closers.forEach(function (b) {
      b.addEventListener("click", close);
    });
    overlay.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  }

  /* ---- faq accordion ---- */
  function initFaq() {
    document.querySelectorAll("[data-faq]").forEach(function (item) {
      var btn = item.querySelector(".faq-q");
      var panel = item.querySelector(".faq-a");
      if (!btn || !panel) return;
      btn.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");
        if (isOpen) {
          item.classList.remove("is-open");
          panel.style.maxHeight = "0px";
        } else {
          item.classList.add("is-open");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  }

  function boot() {
    initReveal();
    initHero();
    initMenu();
    initFaq();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* re-init in Shopify theme editor when sections reload */
  document.addEventListener("shopify:section:load", boot);
})();
